const getDefault = ({ value, defaultValue }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  return defaultValue;
};

export default getDefault;



// WEBPACK FOOTER //
// ./src/utils/print/getDefault.js